import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { apiFetch } from "@/lib/supabase";
import { useNavigate } from "react-router-dom";
import { CalendarDays, ListChecks, AlertCircle } from "lucide-react";
import { StatusBadge, formatDate } from "@/lib/ui";

export default function WeekAhead() {
  const { currentOrgId } = useAuth();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!currentOrgId) return;
    setLoading(true);
    apiFetch(`/digests/preview?organization_id=${currentOrgId}`)
      .then((d) => { setData(d); setLoading(false); })
      .catch(() => setLoading(false));
  }, [currentOrgId]);

  if (loading || !data) return null;
  const nothing = data.counts.tasks_due_this_week === 0 && data.counts.tasks_overdue === 0 && data.counts.appointments_this_week === 0;
  if (nothing) return null;

  return (
    <div className="bg-white rounded-2xl border border-[#E8E2D9] p-6" data-testid="week-ahead">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-display font-semibold text-sm text-[#57534E] uppercase tracking-widest">Your week ahead</h3>
        <div className="text-xs text-[#A8A29E]">Week of {formatDate(data.week_of)}</div>
      </div>
      <div className="grid grid-cols-3 gap-3">
        <button onClick={() => navigate("/app/calendar")} className="text-left p-4 rounded-xl bg-[#FAF8F5] hover:bg-[#FDE9D8]/40 transition-colors" data-testid="wa-appts">
          <CalendarDays size={16} className="text-[#E8712C] mb-2" />
          <div className="text-2xl font-display font-bold">{data.counts.appointments_this_week}</div>
          <div className="text-xs text-[#57534E]">Appointments this week</div>
        </button>
        <button onClick={() => navigate("/app/tasks")} className="text-left p-4 rounded-xl bg-[#FAF8F5] hover:bg-[#FDE9D8]/40 transition-colors" data-testid="wa-due">
          <ListChecks size={16} className="text-[#E8712C] mb-2" />
          <div className="text-2xl font-display font-bold">{data.counts.tasks_due_this_week}</div>
          <div className="text-xs text-[#57534E]">Tasks due this week</div>
        </button>
        <button onClick={() => navigate("/app/tasks?filter=overdue")} className="text-left p-4 rounded-xl bg-[#FAF8F5] hover:bg-[#FDDCDC]/40 transition-colors" data-testid="wa-overdue">
          <AlertCircle size={16} className={data.counts.tasks_overdue > 0 ? "text-[#B02222] mb-2" : "text-[#A8A29E] mb-2"} />
          <div className="text-2xl font-display font-bold">{data.counts.tasks_overdue}</div>
          <div className="text-xs text-[#57534E]">Overdue tasks</div>
        </button>
      </div>
    </div>
  );
}
